import { Construction } from 'lucide-react';

export const ComingSoon = ({ title }) => {
  return (
    <div data-testid={`${title.toLowerCase().replace(/\s+/g, '-')}-page`} className="flex flex-col items-center justify-center min-h-[60vh]">
      <div className="bg-white rounded-sm border border-slate-200 p-12 text-center max-w-md">
        <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Construction className="h-8 w-8 text-orange-500" />
        </div>
        <h1 className="text-3xl font-bold text-slate-900 uppercase tracking-tight mb-3">
          {title}
        </h1>
        <p className="text-slate-500 text-lg">
          Coming Soon
        </p>
        <p className="text-slate-400 text-sm mt-2">
          This feature is under development
        </p>
      </div>
    </div>
  );
};
